import React, { Component } from "react";
import CircularProgress from "material-ui/CircularProgress";

class Loading extends Component {
  render() {
    const size = window.screen.width / 7;
    return (
      <div className="container" style={{ paddingLeft: "0em" }}>
        <br />
        <br />
        <CircularProgress
          color={this.props.color || "#424242"}
          size={size}
          thickness={20}
        />
        <br />
        <br />
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./app/components/Loading.js